import { useCallback, useEffect, useState } from "react";
import { getBranches, getPatientCurrentBranch } from "../../../api/protocol";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";
import { useAuthProtocol } from "../../../components/Authorization/useAuthorization";

const BRANCHES_PERMISSION = ["MedicalRecords.Create", "Visits.Edit"];

export const useBranches = (protocolId, refreshKey) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [isAuthorized, isAuthLoading] = useAuthProtocol(protocolId);
    const canViewBranches = !isAuthLoading && isAuthorized(BRANCHES_PERMISSION);

    const fetchData = useCallback(() => {
        if (!protocolId) return;
        if (!canViewBranches) {
            setData([]);
            return;
        }
        setIsLoading(true);
        setReload(false);
        getBranches(protocolId)
            .then(response => {
                setData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                HandleApiError(error);
                setData([]);
                setIsLoading(false);
            });
    }, [protocolId, canViewBranches]);

    useEffect(() => {
        fetchData();
    }, [fetchData, reload, refreshKey]);

    return [data, isLoading, setReload];
};

export const usePatientBranch = (protocolId, numberInProtocol) => {
    const [branch, setBranch] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [isAuthorized, isAuthLoading] = useAuthProtocol(protocolId);
    const canViewBranches = !isAuthLoading && isAuthorized(BRANCHES_PERMISSION);

    useEffect(() => {
        if (!protocolId || !numberInProtocol) return;
        if (!canViewBranches) {
            setBranch(null);
            return;
        }
        setIsLoading(true);
        setReload(false);
        getPatientCurrentBranch(protocolId, numberInProtocol)
            .then(response => {
                setBranch(response.status === 204 ? null : response.data);
                setIsLoading(false);
            })
            .catch(() => {
                setBranch(null);
                setIsLoading(false);
            });
    }, [protocolId, numberInProtocol, reload, canViewBranches]);

    return [branch, isLoading, setReload];
};
